import { render, staticRenderFns } from "./ResubmissionRedirectStepTwo.vue?vue&type=template&id=0d95a68c&scoped=true&"
import script from "./ResubmissionRedirectStepTwo.vue?vue&type=script&lang=js&"
export * from "./ResubmissionRedirectStepTwo.vue?vue&type=script&lang=js&"
import style0 from "./ResubmissionRedirectStepTwo.vue?vue&type=style&index=0&id=0d95a68c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d95a68c",
  null
  
)

export default component.exports